// this file is generated by update_shopify_store_data.py at 2026-05-05 20:23:59.688857
var courses = [
    {
        "course_id": "F49B1B5A-2B48-EF11-998E-005056A70840",
        "course_version": 1,
        "name": "ANA: Bringing the Nursing Scope and Standards to Life \u2013 Part 2",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\nAs a nurse, you have a duty to integrate the current Nursing Scope and Standards into nursing practice. But how can you and your organization do this effectively?\r\nThis course shifts from Part 1's discussion of the applicability of the Standard's competencies, and moves to a state of application, using the Nursing Scope and Standards as a grounding framework. You will discover tangible strategies to develop a meaningful and comprehensive nursing evaluation tool\u2014for nursing students and registered nurses at all levels and in all specialties.\r\nWe recommend completing the Part 1 course first for the best learning experience.",
        "learning_objectives_html": "Key Learning Outcomes:<br />\r\nDiscover how to implement Nursing Standard 16 for Professional Practice Evaluation using a standardized and progressive nursing evaluation tool<br />\r\nDetermine how to develop a nursing evaluation tool using the Nursing Scope and Standards as a framework",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 1.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];